import React, { useState } from 'react';
import AllRoutes from './routes';
import './App.scss';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

function App() {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000,
          },
        },
      }),
  );
  return (
    <QueryClientProvider client={queryClient}>
      <div className="App">
        <AllRoutes />
      </div>
    </QueryClientProvider>
  );
}

export default App;
